import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  console.log('dynamicRountingconfig', data.dynamicRountingconfig[0].metaDataDetails.failureRate)
  return data.dynamicRountingconfig.map((item: any) => ({
    id: item?.id?.toString(),
    processingEntity: item?.entity?.processingEntity,
    status: item?.entity?.status,
    bankId: item?.bankId.toString(),
    mode: item?.mode,
    subType: item?.method?.subType,
    type: item?.method?.type,
    cardType: item?.card?.type,
    cardScheme: item?.card?.scheme,
    failureRate: defaultIfNull(item?.metaDataDetails?.failureRate),
    plannedDowntimeEndAt: getParsedDate(item?.metaDataDetails?.plannedDowntimeEndAt),
    plannedDowntimeStartAt: getParsedDate(item?.metaDataDetails?.plannedDowntimeStartAt),
    resetAfter: defaultIfNull(item?.metaDataDetails?.resetAfter),
    lastTxnDate: defaultIfNull(item?.metaDataDetails?.lastTxnDate),
  }))
}

const getReqData = (data: any) => {
  const reqData = {
    entity: {
      processingEntity: data.processingEntity,
    },
    bankId: data.bankId ?? '', // optional
    mode: data.mode ?? '', //optional

    method: {
      subType: data.methodSubType,
      type: data.methodType,
    },
    card: {
      type: data.cardType ?? '', //optional
      scheme: data.cardScheme ?? '', //optional
    },
  }
  return reqData
}

const fetchDynamicRouteConfig = (tokens: any, data: any) => {
  console.log('data=', data)
  const reqData = getReqData(data)
  console.log('reqData', reqData)
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.fetchDynamicRouteConfig),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: reqData,
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { fetchDynamicRouteConfig }
const defaultIfNull = (data: any) => {
  if (!data || data === 'null') {
    return ''
  }
  return data
}

const getParsedDate = (data: any) => {
  if (!data || data === 'null') {
    return null
  }
  const date = new Date(data)
  date.setHours(date.getHours() - 5)
  date.setMinutes(date.getMinutes() - 30)
  return date
}
